export default "__VITE_ASSET__CeoBH2zA__"